import { createFileRoute } from "@tanstack/react-router";
import TrusteesPage from "@project/user/pages/trust/trustees";

export const Route = createFileRoute("/_user/_trust/trustees")({
  head: () => ({ meta: [{ title: "Trustees — Jivandhara" }] }),
  component: TrusteesPage,
});
